module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin leer 4.87231ba2.svg";